export const messages = {
  carouselSlides: {
    defaultMessage: 'Carousel slides',
    id: 'fa.carousel.carousel_slides.cta',
  },
  carouselImage: {
    defaultMessage: 'Image carousel',
    id: 'fa.carousel.image_carousel.cta',
  },
  nextSlide: {
    defaultMessage: 'Next slide',
    id: 'fa.carousel.next_slide.cta',
  },
  previousSlide: {
    defaultMessage: 'Previous',
    id: 'fa.carousel.previous_slide.cta',
  },
  disclaimerCta: {
    defaultMessage: 'View disclaimer details',
    id: 'fa.carousel.disclaimer.cta',
  },
  wltpFallback: {
    defaultMessage: 'WLTP data not available.',
    id: 'fa.carousel.wltp.fallback',
  },
};
